import React from "react";
import { Navigate } from "react-router-dom";
import { getUserSession } from "../../utils/userSession";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken");
  const userSession = getUserSession();

  // Verifica se o usuário está autenticado
  const isAuthenticated = !!(accessToken && userSession);

  if (!isAuthenticated) {
    // Redireciona para a página de login se não estiver autenticado
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
